import { Commit } from "components/icons/generated";
import MetaInfoListItem from "components/MetaInfoList/Item";
import { Commit as CommitType, Maybe, VcsIntegration, VcsProvider } from "types/generated";
import { getCommitLabel } from "utils/commit";
import { getRepoRevisionUrl } from "utils/spaceliftRepo";

type MetaInfoSpaceliftCommitProps = {
  vcsIntegration: Maybe<Pick<VcsIntegration, "id">>;
  commit: Maybe<Pick<CommitType, "hash">>;
  commitSetBy: Maybe<string>;
  provider: VcsProvider;
};

const MetaInfoSpaceliftCommit = ({
  vcsIntegration,
  commit,
  commitSetBy,
  provider,
}: MetaInfoSpaceliftCommitProps) => {
  if (!commit || !vcsIntegration) return null;

  const commitUrl = getRepoRevisionUrl(vcsIntegration.id, commit.hash);

  return (
    <MetaInfoListItem
      to={commitUrl}
      linkText={getCommitLabel(provider, commit.hash)}
      icon={Commit}
      tooltip={commitSetBy}
      target="_blank"
    />
  );
};

export default MetaInfoSpaceliftCommit;
